const tlv = (id, value) => `${id}${String(value.length).padStart(2, "0")}${value}`;

const clean = (s, max) =>
  (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^A-Za-z0-9 ]/g, "").toUpperCase().trim().slice(0, max);

const crc16 = (str) => {
  let crc = 0xffff;
  for (let i = 0; i < str.length; i++) {
    crc ^= str.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) crc = crc & 0x8000 ? ((crc << 1) ^ 0x1021) & 0xffff : (crc << 1) & 0xffff;
  }
  return crc.toString(16).toUpperCase().padStart(4, "0");
};

export const parseAmount = (price) => {
  const m = String(price || "").replace(/\./g, "").match(/(\d+)(?:,(\d{1,2}))?/);
  return m ? Number(`${m[1]}.${m[2] || "0"}`) : 0;
};

export const pixPayload = ({ key, name, city, amount }) => {
  if (!key) return "";
  const merchant = tlv("26", tlv("00", "br.gov.bcb.pix") + tlv("01", key.trim()));
  const body =
    tlv("00", "01") +
    merchant +
    tlv("52", "0000") +
    tlv("53", "986") +
    (amount > 0 ? tlv("54", amount.toFixed(2)) : "") +
    tlv("58", "BR") +
    tlv("59", clean(name, 25) || "SDESIGNER") +
    tlv("60", clean(city, 15) || "BRASIL") +
    tlv("62", tlv("05", "***")) +
    "6304";
  return body + crc16(body);
};
